// @flow
import React, { Fragment } from 'react';
import Waypoint from 'react-waypoint';
import { connect } from 'react-redux';
import {
  MdDelete,
  MdAutorenew,
} from 'react-icons/lib/md';
import _ from 'lodash';
import i18n from 'i18n-js';


import type{ USER_TYPE } from '../../types/users';
import styles from './usersList.css';
import { FullLoader } from '../Loader';
import ConfirmDeletionPopup from '../ConfirmDeletionPopup';
import DataTable from '../DataTable';
import TextColumn from '../DataTable/Columns/Text';
import ButtonColumn from '../DataTable/Columns/Button';
import Popup from '../Popup';
import SMSCodePopupContent from '../SMSCodePopupContent';
import { Loading, ConfirmDeletion, NoResults } from '../CommonTexts';
import PlaceholderView from '../PlaceholderViews';
import PlacehorderImage from '../../../assets/images/genericph.png';

import * as closeableActions from '../../actions/closeable';
import * as userActions from '../../actions/users';
import * as selectors from '../../reducers';
import { getUserImage } from '../../utils';

type UsersListPropTypes = {
  users: Array<USER_TYPE>,
  fetchUsers: Function,
  isFetching: boolean,
  nextPage: number,
  hasMore: boolean,
  currentUser: USER_TYPE,
  popupAction: Function,
  updateUser: Function,
};

class UsersList extends React.Component<UsersListPropTypes> {
  _handleLoadMore(page) {
    const { fetchUsers } = this.props;
    fetchUsers(page);
  }

  render() {
    const {
      users = [],
      nextPage = 1,
      hasMore = false,
      isFetching = false,
      currentUser,
      popupAction,
      updateUser,
    } = this.props;

    return (
      <Fragment>
        {
          !isFetching
            && users.length === 0
            && (
              <div className={styles.placeholder}>
                <PlaceholderView
                  size="small"
                  image={PlacehorderImage}
                  title={NoResults(i18n.t('common.user.other', { count: 2 }).toLowerCase())}
                  subtitle={i18n.t('common.noCoincidences')}/>
              </div>
            )
        }
        {
          users.length > 0
          && (
            <div className={styles.resultsContainer}>
              <Fragment>
                {
                  users.map(u => (
                    <Popup
                      key={u.id}
                      id={`genUserCode${u.id}`}
                      theme="main"
                      transitionMs={600}
                    >
                      <SMSCodePopupContent id={u.id} />
                    </Popup>
                  ))
                }
              </Fragment>
              <Fragment>
                <Popup
                  id="confirmDeleteUser"
                  theme="main"
                  transitionType="slideDown"
                  transitionMs={600}
                >
                  {
                    currentUser // El current user ya salio del estado inicial?
                    ? (<ConfirmDeletionPopup
                      onConfirm={() => popupAction()}
                      Icon={MdDelete}
                      descriptionText={ConfirmDeletion(currentUser.first_name)}
                    />) : (<Fragment />)
                  }
                </Popup>
                <DataTable
                  data={users}
                  columns={
                    [
                      // UserColumn({
                      //   Header: 'Usuario',
                      //   accessor: 'user_column',
                      //   maxWidth: 350,
                      // }),
                      TextColumn({
                        Header: i18n.t('labels.userType', { count: 2 }),
                        accessor: 'userType',
                        maxWidth: 250,
                        editable: false,
                      }),
                      TextColumn({
                        Header: i18n.t('labels.name', { count: 2 }),
                        accessor: 'first_name',
                        maxWidth: 200,
                        editable: true,
                        onChange(original, first_name) {
                          updateUser({ ...original, first_name });
                        },
                      }),
                      TextColumn({
                        Header: i18n.t('labels.lastName', { count: 2 }),
                        accessor: 'last_name',
                        maxWidth: 250,
                        editable: true,
                        onChange(original, last_name) {
                          updateUser({ ...original, last_name });
                        },
                      }),
                      TextColumn({
                        Header: i18n.t('labels.phone'),
                        accessor: 'phoneDisplay',
                        maxWidth: 400,
                        editable: true,
                        padded: true,
                        onChange(original, phone) {
                          updateUser({ ...original, phone: `+502${phone}` });
                        },
                      }),
                      TextColumn({
                        Header: i18n.t('labels.email'),
                        accessor: 'email',
                        maxWidth: 400,
                        editable: true,
                        onChange(original, email) {
                          updateUser({ ...original, email });
                        },
                      }),
                      TextColumn({ Header: '', accessor: 'none', maxWidth: 100 }),
                      ButtonColumn({
                        Header: '',
                        accessor: 'openCodePopup',
                        buttonProps: {
                          Icon: MdAutorenew,
                          title: '',
                          size: 'small',
                          isTransparent: true,
                          tint: 'main',
                          isOutlined: true,
                          iconPosition: 'right',
                        },
                        maxWidth: 50,
                      }),
                      ButtonColumn({
                        Header: '',
                        accessor: 'remove_button',
                        buttonProps: {
                          Icon: MdDelete,
                          title: '',
                          size: 'small',
                          isTransparent: true,
                          tint: 'error',
                          isOutlined: true,
                          iconPosition: 'right',
                        },
                        maxWidth: 50,
                      }),

                    ]
                  }
                  defaultPageSize={999999}
                  minRows={0}
                  showPagination={false}
                />
                <Waypoint
                  onEnter={() => hasMore && this._handleLoadMore(nextPage)}
                  viewportBottom={20}
                />
              </Fragment>
            </div>
          )
        }
        {
          isFetching && (
            <FullLoader
              tint="main"
              title={Loading(i18n.t('common.user', { count: 2 }))}
            />
          )
        }
      </Fragment>

    );
  }
}

// removeUserStart
export default connect(
  (state) => {
    const users = selectors.getUsers(state);
    const types = {
      parent_profile: i18n.t('labels.parent', { count: 1 }),
      driver_profile: i18n.t('labels.driver'),
      student_profile: i18n.t('labels.students', { count: 1 }),
      monitor_profile: i18n.t('labels.monitor', { count: 1 }),
    };
    const parsedUsers = users.map((user) => {
      let href;
      switch (user.result_type) {
        case 'student_profile':
          href = `/admin/map/students/${user.profile_id}`;
          break;
        case 'monitor_profile':
          href = `/admin/map/monitors/${user.profile_id}`;
          break;
        default:
          href = '';
          break;
      }
      const phoneSplit = user.phone.split('+502');
      let phoneDisplay = user.phone;
      if (phoneSplit.length > 1) {
        phoneDisplay = user.phone.split('+502')[1];
      }
      let userType = '';
      if (user.result_type === 'student_profile'){
        userType = 'Estudiante';
      }
      else if(user.result_type === 'parent_profile'){
        userType = 'Padre';
      }
      return {
        ...user,
        profile_picture: getUserImage(user.profile_picture),
        phoneDisplay,
        userType,
        user_column: {
          id: user.id,
          firstName: user.first_name,
          lastName: user.last_name,
          pictureURL: getUserImage(user.profile_picture),
          phoneDisplay,
          userRole: types[user.result_type],
          href,
        },
      };
    });
    return {
      users: parsedUsers,
      hasMore: selectors.hasMoreUsers(state),
      nextPage: selectors.getUserNextPage(state),
      isFetching: selectors.isUsersFetching(state),
      currentUser: selectors.getUserSelected(state),
    };
  },
  dispatch => ({
    fetchUsers(page) {
      dispatch(userActions.startFetchingUsers(page));
    },
    buttonSelectUser(userId: number) {
      dispatch(userActions.selectUser(userId));
    },
    removeUser(orderId, id, popupID, result_type) {
      dispatch(userActions.removeUserStart(orderId, id, result_type));
      dispatch(closeableActions.close(popupID));
    },
    openPopup(id) {
      dispatch(closeableActions.open(id));
    },
    updateUser(user) {
      dispatch(userActions.updateUserStart({ ...user }));
    },
  }),
  ({ users, currentUser, ...stateProps }, {
    removeUser, buttonSelectUser, openPopup, ...dispatchProps
  }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    currentUser,
    popupAction: () => removeUser(currentUser.id, currentUser.profile_id, 'confirmDeleteUser', currentUser.result_type),
    users: users.map(
      el => ({
        ...el,
        remove_button: {
          onClick: () => {
            buttonSelectUser(el.id);
            openPopup('confirmDeleteUser');
          },
        },
        openCodePopup: {
          onClick: () => {
            buttonSelectUser(el.id);
            openPopup(`genUserCode${el.id}`);
          },
        },
      }),
    ),
  }),
  {
    areStatesEqual(next, prev) {
      return _.isEqual(next.users, prev.users);
    },
  },
)(UsersList);



// WEBPACK FOOTER //
// ./src/scripts/components/UsersList/index.jsx